export function swissAmount(value) {
  const [integer, fraction] = Number(value).toFixed(2).split('.');
  return integer.replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + fraction;
}
